const popupContent = {
  title: '팝업 관리 매뉴얼',
  content: `
  <div class="page-title">[팝업 관리]</div>
  
# [개요]
팝업 관리 기능은 웹사이트의 팝업을 효율적으로 관리하기 위한 도구입니다. 이 문서에서는 **팝업의 등록, 수정, 조회 등 전반적인 관리 방법**을 확인할 수 있습니다.

### 주요 기능 요약
| 기능 | 설명 | 권한 |
|------|------------------|------------|
| 팝업 조회 | 등록된 팝업 목록 확인 및 검색 | 관리자 |
| 팝업 등록 | 신규 팝업 생성 및 설정 | 관리자 |
| 팝업 수정 | 기존 팝업 정보 수정 | 관리자 |

# [조회]
등록된 팝업의 목록을 조회하고 관리할 수 있습니다.

### 📋 화면 구성 및 기능
| 영역 | 구성 | 주요 기능 |
|------|------|-----------|
| 검색 영역 | 검색 조건 및 필터 | • 상태/언어/기간별 검색<br>• 제목/내용 기준 검색 |
| 목록 영역 | 팝업 목록 테이블 | • 상태/기간/사용여부 확인 |
| 버튼 영역 | 등록 버튼 | • 신규 팝업 등록 |

![팝업 목록](/assets/images/guide/popup/list.png)

# [등록/수정]
팝업을 신규 등록하거나 기존 팝업의 상세 정보를 수정할 수 있습니다.

> ⚠️ **주의사항**
> - 위치값은 화면 좌상단 기준입니다.
> - 설정된 너비값(width)을 100% 기준으로 하여 에디터에서 작성한 비율이 실제 화면에 동일하게 적용됩니다.
> - 예시) 너비 1000px 설정 시, 에디터에서 50%로 작성한 콘텐츠는 500px로 표시
> - 저장 즉시 반영됩니다.

### 📋 화면 구성 및 기능
| 영역 | 입력 항목 | 설명 |
|------|-----------|------|
| 기본 설정 | • 언어<br>• 노출환경<br>• 팝업 제목 | • 노출 언어 선택<br>• PC/모바일 환경 설정<br>• 관리용 제목 (미노출) |
| 노출 설정 | • 노출 시작일/종료일<br>• 비활성화 시간<br>• 상단/좌측 위치<br>• 가로/세로 크기 | • 시작/종료일 + 시간 설정<br>• 비활성화 기간 설정<br>• 화면 기준 x,y 위치(px)<br>• 팝업 크기 설정(px) |
| 콘텐츠 | • 팝업 내용 | • 실제 노출될 팝업 내용 |

![팝업 등록/수정](/assets/images/guide/popup/edit.png)
    `,
};
export default popupContent;
